import {
  init_payment_method_section,
  remove_payment_method_section,
} from "./payment-method-section.scripts.js";
import { init_purchase_summary_section } from "./purchase-summary-section.scripts.js";
import { init_region_modal_listeners } from "./region-modal.scripts.js";
import { init_checkout_page_client } from "./payment-orchestrator.js";

const init_checkout = () => {
  console.log("init_checkout on DOMContentLoaded or pageshow");

  init_payment_method_section();
  init_purchase_summary_section();
  init_region_modal_listeners();
  init_checkout_page_client();

  remove_payment_method_section();
};

init_checkout();
